export const SET_ASSETS = 'SET_ASSETS'
